import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Box from '@mui/material/Box';
import { ImageList, ImageListItem, useTheme } from '@mui/material';
import Fancybox from '../Fancybox/Fancybox';
import useMediaQuery from '@mui/material/useMediaQuery';
import { MentionContractuel } from '../Mention/MentionContractuel';

export function Illustrations() {
  const theme = useTheme();
  const infos = useOutletContext();
  const hasIllustrations = infos?.settings?.illustrations?.show;
  const illustrations = infos?.settings?.illustrations?.data;
  const sm = useMediaQuery(theme.breakpoints.up('sm'));
  const md = useMediaQuery(theme.breakpoints.up('md'));

  if (!hasIllustrations) return null;

  return (
    <Box
      sx={{
        height: '100%',
        overflow: 'auto',
        padding: '8px',
      }}
    >
      <MentionContractuel sx={{ zIndex: 1 }} />
      <Fancybox options={{ infinite: false }}>
        <ImageList variant="masonry" cols={sm ? (md ? 3 : 2) : 1} gap={8}>
          {illustrations.map((item, index) => (
            <ImageListItem sx={{ cursor: 'pointer' }} key={item.url}>
              <img
                data-fancybox="illustrations"
                data-src={item.url}
                src={`${item.url}?w=248&fit=crop&auto=format`}
                srcSet={`${item.url}?w=248&fit=crop&auto=format&dpr=2 2x`}
                alt={`image-${index}`}
                loading="lazy"
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Fancybox>
    </Box>
  );
}
